/* globals twemoji  */

import path from 'path';
import Vue from 'vue'
import App from './App.vue'
import '@/assets/tailwind.css'
/* TODO: do we need? import 'codemirror/lib/codemirror.css'; */
import '@/assets/_codemirror.css';


import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faTimes, faPlus, faMinus, faChevronRight, faEdit, faCalendar, faPaperclip, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import PortalVue from 'portal-vue'
import Toasted from 'vue-toasted';


import router from './router'
import store from './store'
import data from './data'
import lib from '@/components/_library_';

if (!window.twemoji) {
  window.twemoji = {
    parse: i => i
  }
}

// utils
Array.prototype.unique = function() {
  return this.filter(function (value, index, self) { 
    return self.indexOf(value) === index;
  });
}

Vue.prototype.$nav = function (page, {
  folder,
  tags,
  extra
}) {

  window.scrollTo(0, 0);

  this.$router.push(path.join(
    '/',

    page || '/',
    // path
    folder || this.$route.params.path || '/',
    // tags
    tags || this.$route.params.tags ||  '/',

    extra || '/',
  ));
}
// end utils

library.add(faBars, faTimes, faPlus, faMinus, faChevronRight, faEdit, faCalendar, faPaperclip, faTrash)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(Toasted)
Vue.use(PortalVue)

const bootstrap = async () => {
  await store.dispatch('init')
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}

bootstrap();
